import React from 'react';

function ModalDialog({ 
  isOpen, 
  title, 
  message, 
  onConfirm, 
  onCancel,
  confirmLabel = "Aceptar",
  cancelLabel = "Cancelar",
  type = "confirm",
  showImageSelector = false,
  onImageSelected = null 
}) {
  if (!isOpen) return null;

  // Determinar los colores basados en el tipo
  let bgColor, buttonColor;
  switch (type) {
    case 'warning':
      bgColor = 'bg-yellow-50';
      buttonColor = 'bg-yellow-500 hover:bg-yellow-600';
      break;
    case 'error':
      bgColor = 'bg-red-50';
      buttonColor = 'bg-red-500 hover:bg-red-600';
      break;
    case 'alert':
      bgColor = 'bg-blue-50';
      buttonColor = 'bg-blue-500 hover:bg-blue-600';
      break;
    default:
      bgColor = 'bg-white';
      buttonColor = 'bg-green-500 hover:bg-green-600';
  }

  // Verificar si el mensaje contiene valores numéricos (como saldo)
  const formatMessage = () => {
    if (typeof message !== 'string') return message;
    
    // Buscar patrón como "$25.00" o "$25" para resaltar
    return message.split(/(\$\d+(?:\.\d+)?)/).map((part, index) => {
      if (part.startsWith('$') && /\d/.test(part)) {
        // Si es un valor monetario, aplicar formato especial
        return <span key={index} className="text-4xl font-extrabold text-green-400">{part}</span>;
      }
      return <span key={index}>{part}</span>;
    });
  };

  // Manejador para la selección de imagen
  const handleImageChange = (e) => {
    if (onImageSelected && e.target.files && e.target.files[0]) {
      onImageSelected(e.target.files[0]);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="fixed inset-0 bg-black bg-opacity-70" onClick={onCancel}></div>
      <div className={`${bgColor} p-10 rounded-xl shadow-2xl w-11/12 max-w-3xl mx-4 relative z-10`}>
        <div className="text-center">
          {title && (
            <h3 className="text-3xl font-extrabold mb-5">{title}</h3>
          )}
          
          <div className="text-xl font-medium mb-8">
            {formatMessage()}
          </div>
          
          {/* Selector de imagen opcional */}
          {showImageSelector && (
            <div className="mb-6">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Seleccionar imagen de perfil (opcional)
              </label>
              <input 
                type="file" 
                accept="image/*"
                onChange={handleImageChange}
                className="w-full text-sm text-gray-500
                  file:mr-4 file:py-2 file:px-4
                  file:rounded-md file:border-0
                  file:text-sm file:font-semibold
                  file:bg-blue-50 file:text-blue-700
                  hover:file:bg-blue-100"
              />
            </div>
          )}
          
          <div className="flex justify-center space-x-6 mt-8">
            {type === 'confirm' && (
              <button
                className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-4 px-8 rounded-lg text-xl"
                onClick={onCancel}
              >
                {cancelLabel}
              </button>
            )}
            
            <button
              className={`${buttonColor} text-white font-bold py-4 px-10 rounded-lg text-xl`}
              onClick={onConfirm}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalDialog;
